import {
    KPI_PLANNING_CATEGORIES, DESTINATION_ITEMS, HABITS_ITEMS, 
    JOB_KPIS, JOB_LIST, KPI_PLANNING_KPI_LIST, ALL_JOB_KPIS
} from './../actions/ActionTypes';
import InitialState from './InitialState';


// Compare Item for sorting
const compareKPIItem = (a, b) => {
    if (a.name.toUpperCase() < b.name.toUpperCase()) {
        return -1;
    }
    if (a.name.toUpperCase() > b.name.toUpperCase()) {
        return 1;
    }
    return 0;
};

const KPIPlanningReducer = (state = InitialState.kpiPlanning, action) => {
    switch (action.type) {
        case KPI_PLANNING_CATEGORIES: {
            // destination categories (columns)
            let data = {...state};
            data.categories =  action.categories;
            return data;
        }

        case DESTINATION_ITEMS: {
            // destination items (columns)
            let data = {...state};
            data.destinationItems =  action.destinationItems;
            return data;
        }

        case HABITS_ITEMS: {
            // destination items (columns)
            let data = {...state};
            data.habitItems =  action.habitItems;
            return data;
        }

        case KPI_PLANNING_KPI_LIST: {
            // kpi list
            let data = {...state};
            data.kpiList =  action.kpiList;
            return data;
        }

        case JOB_KPIS: {
            // kpi list assigned for a job title
            let data = {...state};
            let kpiList = action.kpiList;
            kpiList.sort(compareKPIItem);
            data.jobKPIs =  kpiList;
            return data;
        }

        case ALL_JOB_KPIS: {
            // kpi list assigned for all job title
            let data = {...state};
            let kpiList = action.kpiList;
            kpiList.sort(compareKPIItem);
            data.allJobKPIs =  kpiList;
            return data;
        }

        case JOB_LIST: {
            // Job title list
            let data = {...state};
            data.jobTitleList =  action.jobList;
            return data;
        }

        default:
            return state;
    }
};

export default KPIPlanningReducer;



// WEBPACK FOOTER //
// ./src/reducers/KPIPlanningReducer.js